module.exports = __webpack_public_path__ + "static/media/oda-sistemi.cfe99044.png";